import "./components/nav"
import "./components/carousel"
import "./components/accordion"
import "./components/videoSplash"

document.documentElement.classList.remove('no-js')
